import { TitleText, FlexRowBetween, FlexRow } from 'components'
import { Checkbox, Modal } from 'semantic-ui-react'
import { AppButton, AppPrimaryButton } from 'elements'
import { X } from 'phosphor-react'
import { GroupService } from 'utility/services'
import { useEffect, useState } from 'react'

const GroupItem = ({ item, onSelect, value }) => {
    return (
        <p className="d-flex align-items-center" onClick={onSelect}>
            <Checkbox checked={value} onChange={onSelect} className="me-3" />
            {item.GroupName}
        </p>
    )
}

export const GroupListModal = ({ open, onClose }) => {
    const [data, setData] = useState([])
    const [ids, setIds] = useState([])
    const [loading, setLoading] = useState(false)
    const [dataLoading, setDataLoading] = useState(false)

    const onSelect = id => {
        if (ids.includes(id)) {
            setIds(ids.filter(ele => ele !== id))
        } else {
            setIds([...ids, id])
        }
    }
    // Fetch groups data only when modal opens
    useEffect(() => {
        const fetchGroups = async () => {
            if (open && data.length === 0) {
                setDataLoading(true)
                try {
                    const result = await GroupService.list({})
                    setData(result.Items || [])
                } catch (error) {
                    console.error('Failed to fetch groups:', error)
                    setData([])
                } finally {
                    setDataLoading(false)
                }
            }
        }
        fetchGroups()
    }, [open, data.length])

    useEffect(() => {
        if (open) {
            setIds([])
        }
    }, [open])

    // const onSubmit = () => {
    //     onClose(ids)
    // }
    // const onSubmit = async () => {
    //     setLoading(true)
    //     try {
    //         await new Promise(resolve => setTimeout(resolve, 1000));
    //         onClose(ids)
    //     } finally {
    //         setLoading(false)
    //     }
    // }
    const onSubmit = async () => {
        if (loading) return;

        setLoading(true)
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            onClose(ids)
        } finally {
            setLoading(false)
        }
    }
    return (
        <Modal
            title="Send to Group"
            open={open}
            onCancel={onClose}
            className="model"
            size="small"
        >
            <Modal.Header>
                <FlexRowBetween>
                    <TitleText>Send to Group</TitleText>
                    <X
                        className="pointer"
                        size={32}
                        onClick={() => onClose()}
                    />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                {dataLoading && <div>Loading groups...</div>}
                {!dataLoading && data.length > 0 && data.map(ele => (
                    <GroupItem
                        key={ele.GroupId}
                        value={ids.includes(ele.GroupId)}
                        onSelect={() => onSelect(ele.GroupId)}
                        item={ele}
                    />
                ))}
                {!dataLoading && data.length === 0 && <div>No groups available</div>}
                <FlexRow className="justify-content-end">
                    <AppPrimaryButton type="button" onClick={onSubmit} loading={loading} disabled={loading || ids.length === 0}>
                        Submit
                    </AppPrimaryButton>
                    <AppButton type="button" onClick={onClose}>
                        Cancel
                    </AppButton>
                </FlexRow>
            </Modal.Content>
        </Modal>
    )
}